<button [disabled]="params.isLoading" class="btn btn-xs btn-primary" (click)="onClick($event)">
  {{ params.label }}
</button>
